import { combineReducers } from 'redux';
import { paymentMethodReducer, PaymentMethodState } from '@domain/billing/payment-method/payment-method.state';
import { subscriptionReducers, SubscriptionState } from './subscription/subscription.state';
import { BillingInterfaceState, interfaceReducers } from './interface/interface.state';
import { interfaceMiddlewares } from './interface/interface.middleware';
import { subscriptionMiddlewares } from './subscription/subscription.middlewares';
import { orderMiddlewares, orderReducers } from './order';
import { billingDetailsReducers, billingDetailsMiddlewares } from './details';
import { ibgeReducers, ibgeMiddlewares } from './ibge';
import { BillingOrderState } from './order/order.state';
import { billingCenterMiddleware } from './center/center.middleware';
import { billingCenterReducer } from './center/center.state';
import { stripeCustomerReducers, stripeCustomerMiddleware } from './stripe/stripe-customer';
import { paymentMethodMiddlewares } from './payment-method/payment-method.middlewares';

export interface State {
    billing: BillingState;
}

export interface BillingState {
    interface: BillingInterfaceState;
    order: BillingOrderState;
    subscription: SubscriptionState;
    paymentMethod: PaymentMethodState;
}

export const billingMiddlewares = [
    interfaceMiddlewares,
    subscriptionMiddlewares,
    billingCenterMiddleware,
    ...orderMiddlewares,
    billingDetailsMiddlewares,
    ibgeMiddlewares,
    stripeCustomerMiddleware,
    paymentMethodMiddlewares,
];

export const billingReducer = combineReducers({
    center: billingCenterReducer,
    subscription: subscriptionReducers,
    order: orderReducers,
    interface: interfaceReducers,
    details: billingDetailsReducers,
    ibge: ibgeReducers,
    stripeCustomer: stripeCustomerReducers,
    paymentMethod: paymentMethodReducer,
});
